import React, { useState, forwardRef, memo, useRef, useCallback, useEffect, useImperativeHandle } from 'react';
import { useMap } from "react-leaflet";
import TopicSvg from "../../../../../assets/images/topic-icon.svg";
import localShippingSvg from "../../../../../assets/images/shipment-move-bl.svg";
import descriptionSvg from "../../../../../assets/images/description.svg";
import modeOfTravelSvg from "../../../../../assets/images/trip.svg";
import resourcesSvg from "../../../../../assets/images/card-resources.svg";
import partialTripSvg from "../../../../../assets/images/partial-trip-bl.svg";
import changeroutesicon from '../../../../../assets/images/change-routes.svg';
import calculatoricon from '../../../../../assets/images/bx-calculator.svg';
import shipmentmoveblicon from '../../../../../assets/images/shipment-move-bl.svg';
import deleteTripIconSvg from '../../../../../assets/images/delete-trip.svg';
import trashBinSvg from '../../../../../assets/images/trash-bin.svg';

import getSetDataService from "../../../../../shared/common-utilities/services/getSetDataService";
import 'leaflet-path-drag';
import i18_en from '../../../../../jsonStore/i18_en.json';
import { markerSelectionReducer } from "../../../../../shared/ReduxStore/Reducers/markerSelectReducer";
import { useDispatch } from "react-redux";
import { baseUrl, getMovement, getPartialTrip, planMovementsNew, postSetFreeRoutes, getRoutes, getShipmentActions } from "../../../../../shared/common-utilities/services/commonUrlConsts/commonUrlConsts";
import commonApiService from "../../../../../shared/common-utilities/services/commonApiService";
import { CommonConst as Consts } from "../../../../../shared/common-utilities/enums/CommonConst.jsx";
import ReactDOMServer from 'react-dom/server';
import MarkerSvgIcon from "../../../../../shared/common-utilities/utils/MarkerSvgIcon";
import ModalComponent from "../../Modal/ModalComponent";
import { PlanFunctionsForFlag } from "../../../../../shared/common-utilities/enums/PlanFunctionsEnum";
import AlertComponent from "../../../../../shared/common-utilities/common/AlertComponent";
import { refreshMapData } from "../../../../../shared/ReduxStore/Reducers/mapRefreshReducer";
import WindowComponent from "../../Window/WindowComponent";
import { DatePicker as KendoDatePicker } from "@progress/kendo-react-dateinputs";
import { Box, Button, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import moment from 'moment';
import { areaSelectionReducer } from "../../../../../shared/ReduxStore/Reducers/areaSelectionReducer";
import { areaSelectionRefreshReducer } from "../../../../../shared/ReduxStore/Reducers/areaSelectionReducer";
import { listSelectionReducer } from "../../../../../shared/ReduxStore/Reducers/listSelectionReducer";
import dataStorageService from "../../../../../shared/common-utilities/services/DataStorageService";
import DeleteTripIcon from '../../../../../shared/common-utilities/utils/DeleteTripIcon';

let service = getSetDataService();
const apiService = commonApiService();
const storageService = dataStorageService();
let routeId = '';
let source = '';
const toDayDate = new Date();
const minDate = new Date(toDayDate.getFullYear() - 50, toDayDate.getMonth(), toDayDate.getDate());
const maxDate = new Date(toDayDate.getFullYear() + 50, toDayDate.getMonth(), toDayDate.getDate());
let selectionData = [];

const ClusterComponent = forwardRef(({ data, selectionCluster, sendDataToParent }, ref) => {
    const map = useMap();
    const dispatch = useDispatch();
    const polylinesRef = useRef([]);
    const drageItems = useSelector(state => state.drag);
    const existingSelectedData = useSelector(state => state.listSelection);
    const initialPosMarkerRef = useRef(new Map());
    const initialPosPolylineRef = useRef(new Map());
    const [polylineColor, setPolylineColor] = useState(Consts.ColorDefault);
    const [commonPopupParameters, setCommonPopupParameters] = useState({});
    const [errorMessage, setErrorMessage] = useState(null);
    const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
    const [isSuccessSnackbarOpen, setSuccessSnackbarOpen] = useState(false);
    const [successSnackbarMessage, setSuccessSnackbarMessage] = useState('');
    const [isErrorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
    const [errorSnackbarMessage, setErrorSnackbarMessage] = useState('');
    const [isDisplayDrillDownButton, setIsDisplayDrillDownButton] = useState(false);
    const [openPlanNewTripPopup, setOpenPlanNewTripPopup] = useState(false);
    const [currentDate, setCurrentDate] = useState("");
    const [selectedIds, setSelectedIds] = useState([]);
    const [allSelectedIds, setAllSelectedIds] = useState([]);
    const [drillDownButtonURL, setDrillDownButtonURL] = useState();
    const [leafletLayerId, setLeafletLayerId] = useState();
    const colorIndexRef = useRef(0);

    useImperativeHandle(ref, () => ({
        onPlanButtonsOptimizeRoute(ptrId) {
            onPlanButtons(null, 'optimizeRoute', ptrId)
        },
        onDropEvent(layerId) {
            setLeafletLayerId(layerId);
            onDropEvent(layerId);
        }
    }));

    useEffect(() => {
        setAllSelectedIds(existingSelectedData);
    }, [existingSelectedData]);

    useEffect(() => {
        setAllSelectedIds(existingSelectedData);
    }, [existingSelectedData]);

    useEffect(() => {
        const markers = L.markerClusterGroup();
        // const _keys = Object.keys(data);
        const polylinesData = data?.filter(item => item.type === 'polyline');
        const polylines = [];
        const selectedData = [];
        // Clear previous markers and polylines
        //markers.clearLayers();
        // polylinesRef.current?.forEach(polyline => map.removeLayer(polyline));

        // marker
        clearMap();
        data.forEach((item) => {
            if (item.latitude !== null && item.longitude !== null && item.actionNo) {
                let icon;
                if (item.source === 'movements') {
                    icon = service.createCustomIcon(service.generateIconWithSelection(item.actionNo, item.selected), map.getZoom());
                    selectedData.push({ type: 'marker', id: item.id, subid: item.subid, isSelection: item.selected, source: item.source });
                } else if (item.source === 'partialTrips') {
                    icon = service.createCustomIcon(null, map.getZoom(), item?.sequenceNo, item.selected);
                    selectedData.push({ type: 'polyline', id: item.id, subid: item.subid, isSelection: item.selected, source: item.source });
                }
                const marker = generateMarkers(item, icon)
                if (selectionCluster) {
                    markers.addLayer(marker);
                } else {
                    map.addLayer(marker);
                }

            }
        });

        // polyline
        const polylineLayers = [];
        const groupedPolylines = _.groupBy(polylinesData, 'id');

        Object.values(groupedPolylines)?.forEach(group => {
            const _group = _.sortBy(group, 'sequenceNo')
            const _color = generateColor();
            for (let i = 0; i < _group.length; i++) {
                if (i !== _group.length - 1) {
                    let _polylineData = []
                    _polylineData.push(_group[i])
                    _polylineData.push(_group[i + 1])
                    const polyline = generatePolylines(_polylineData, _group[i + 1].selected, _color, false);
                    if (polyline?.options?.item?.source != Consts.Movements) {
                        polylineLayers.push(polyline);
                    }
                } else if (_group.length > 1) {
                    if (_group[_group.length - 1]?.dottedLine) {
                        let _polylineData = []
                        _polylineData.push(_group[_group.length - 1])
                        _polylineData.push(_group[0])
                        const polyline = generatePolylines(_polylineData, _group[_group.length - 1].selected, '#606060', true);
                        if (polyline?.options?.item?.source != Consts.Movements) {
                            polylineLayers.push(polyline);
                        }
                    }
                }
            }

            // for (const record of _group) {
            //     if (resource.id === id) {
            //         return resource;
            //     }
            // }
            // if (group.length >= 2) {
            //     const polyline = generatePolylines(group, group[0].selected, _color);
            //     polylineLayers.push(polyline);
            // }
        });

        polylinesRef.current = polylineLayers;
        dispatchSelection(selectedData, 'polyline');
        map.addLayer(markers);

        return () => {
            map.removeLayer(markers);
            polylines?.forEach(polyline => map.removeLayer(polyline));
        };
    }, [map, data, selectionCluster]);


    const sendApi = (e, url) => {
        const urlSuffix = `Microsoft.NAV.${url}`;
        const selectedId = e?.relatedTarget?.options?.item?.id || routeId;
        const sourceItem = e?.relatedTarget?.options?.item?.source || source;
        const webUrl = sourceItem === "partialTrips" ? getPartialTrip : getMovement;

        apiService.postWithId(webUrl, null, selectedId, urlSuffix, {}).then(res => {
            const newUrl = res.value;
            if (newUrl) {
                window.open(newUrl, '_blank');
            }
        });
    }

    const clearMap = () => {
        for (const i in map._layers) {
            if (map._layers[i]?.options?.item != undefined) {
                try {
                    map.removeLayer(map._layers[i]);
                }
                catch (e) {
                    console.log("problem with " + e + map._layers[i]);
                }
            }
        }
    }

    const onPlanButtons = (e, url, idFromParent) => {
        const selectedId = e?.relatedTarget?.options?.item?.id || selectionData?.partialTripIds?.[0];
        if (url === 'optimizeRoute') {
            if (selectedId || idFromParent) {
                // sendDataToParent('optimize-route');
                onPlanButtonsOptimizeRoute(baseUrl, 'partialTrips', (selectedId || idFromParent));
            } else {
                setErrorSnackbarOpen(true);
                setErrorSnackbarMessage(i18_en.selectPartialTrip);
            }
        } else if (url === 'calculatePartialTrip') {
            sendDataToParent('calculate-partial-trip');
        } else if (url === 'setFree') {
            sendDataToParent('set-free');
        } else if (url === 'planOnNewTrip') {
            sendDataToParent('planon-new-trip');
        } else if (url === 'deleteTrip') {
            sendDataToParent('delete-partial trip');
        } else if (url === 'removeFromMap') {
            sendDataToParent('remove-from-map');
        }
    };

    const onPlanButtonsOptimizeRoute = (url, flag, selectedId) => {
        const param = {
            input: "{}"
        };
        apiService.postWithId(url, flag, selectedId, 'Microsoft.NAV.optimizeRouteAndGetRouteDetails', param).then(response => {
            if (response !== null && response !== undefined && response.error !== null && response.error !== undefined && response.error) {
                setErrorParameterAndMessage(response.error.message.split('CorrelationId')[0]);
            } else {
                const _coordinates = JSON.parse(response.value)?.mapInformation?.polyline?.coordinates;
                if (_coordinates) {
                    let _mapselecteddata = _.entries(map._layers).map(p => p[1]).find(e => e?.options?.item?.id == selectedId && e?._latlngs)
                    if (!_.isNil(_mapselecteddata)) {
                        _mapselecteddata.setLatLngs(_coordinates?.map((coord) => { return [coord[1], coord[0]] }))
                    }
                }
                // in progress
            }
        })
            .catch(error => {
                console.error('API error:', error);
            })
    }

    const callPlanFunctionPostWithIdAPI = (url, flag, id, routeExpand, obj, forFlag, isRefresh, snackbarMessage = i18_en.operationSuccessful) => {
        apiService.postWithId(url, flag, id, routeExpand, obj).then(response => {
            if (response) {
                if (response.error) {
                    setErrorParameterAndMessage(response?.error?.message.split('CorrelationId')[0]);
                } else {
                    const result = JSON.parse(response?.value);
                    if (result) {
                        if (service.apiOKResultChecker(result)) {
                            setSuccessSnackbarAndMessage(snackbarMessage);
                            if (isRefresh) {
                                dispatch(refreshMapData({ isRefreshMapData: true }));
                            }
                            setOpenConfirmationModal(false);
                        } else if (result.parameters[0] !== null && result.parameters[0] !== undefined && (result.parameters[0].name === 'confirmation' || result.parameters[0].name === 'warnings')) {
                            const params = {
                                title: result.parameters[0]?.caption ? result.parameters[0].caption : i18_en.navitransTransportPlanning,
                                id: id,
                                for: forFlag,
                                parameters: result.parameters,
                                result: result,
                                obj: obj
                            }
                            setOpenConfirmationModal(true);
                            setCommonPopupParameters(params);
                        } else {
                            setOpenConfirmationModal(false);
                        }
                    } else {
                        setOpenConfirmationModal(false);
                    }
                }
            }
        })
    }

    const postPlanMovementsAPI = (obj, movementObjects) => {
        apiService.post(planMovementsNew, obj).then(response => {
            if (response !== null && response !== undefined) {
                if (response.error !== null && response.error !== undefined && response.error) {
                    setErrorParameterAndMessage(response.error.message.split('CorrelationId')[0]);
                } else {
                    const result = JSON.parse(response?.operationDetail[0]?.result);
                    const successMessage = result?.drillDownMessage ? result?.drillDownMessage : i18_en.tripCreatedSuccessfully;
                    const drillDownURL = result?.drillDownUrl ? result?.drillDownUrl : '';
                    if (service.apiResultChecker(result)) {
                        const param = {
                            title: result.parameters[0]?.caption ? result.parameters[0].caption : i18_en.navitransTransportPlanning,
                            for: PlanFunctionsForFlag.PlanMovementsNewNotification,
                            parameters: result.parameters
                        };
                        setOpenConfirmationModal(true);
                        setCommonPopupParameters(param);
                        if (service.apiOKResultChecker(result)) {
                            setSuccessSnackbarAndMessage(successMessage);
                            setDrillDownFlagAndURL(false, drillDownURL);
                            clearMap();
                            dispatch(areaSelectionRefreshReducer({ isRefresh: true }));
                        }
                    } else if (result?.parameters && (result.parameters[0]?.type === 'Dialog.ConfirmSingleLine' || result.parameters[0]?.type === 'Dialog.SelectRadioButton')) {
                        const input = response?.operationDetail[0]?.input ? JSON.parse(response?.operationDetail[0]?.input) : null;
                        const param = {
                            movementlines: movementObjects,
                            title: result.parameters[0]?.caption ? result.parameters[0].caption : i18_en.navitransTransportPlanning,
                            for: PlanFunctionsForFlag.PlanMovementsNewConfirmation,
                            parameters: result.parameters,
                            input: input,
                            obj: obj?.operationDetail[0]?.input
                        };
                        if (result.parameters[0].type === 'Dialog.ConfirmSingleLine') {
                            param.data = result.data;
                        } else if (result.parameters[0].type === 'Dialog.SelectRadioButton') {
                            param.planOnPartialTrip = input?.planOnPartialTrip;
                        }
                        setOpenConfirmationModal(true);
                        setCommonPopupParameters(param);
                    } else {
                        if (service.apiOKResultChecker(result)) {
                            setSuccessSnackbarAndMessage(successMessage);
                            setDrillDownFlagAndURL(false, drillDownURL);
                            setOpenConfirmationModal(false);
                            clearMap();
                            dispatch(areaSelectionRefreshReducer({ isRefresh: true }));
                        }
                    }
                }
            }
        })
    }

    const setErrorParameterAndMessage = (errMsg) => {
        setCommonPopupParameters({
            title: 'Error'
        });
        setErrorMessage(errMsg);
        setOpenConfirmationModal(true);
    };

    const setSuccessSnackbarAndMessage = (message, noDrillDown = true) => {
        setSuccessSnackbarMessage(message);
        setSuccessSnackbarOpen(true);
        if (noDrillDown) {
            setDrillDownFlagAndURL(false, '');
        }
    };

    const handleSuccessSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSuccessSnackbarOpen(false);
    };

    const handleErrorSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setErrorSnackbarOpen(false);
    };

    const setDrillDownFlagAndURL = (flag = false, drillDownULR = '') => {
        setIsDisplayDrillDownButton(flag);
        setDrillDownButtonURL(drillDownULR);
    }

    const closeConfirmationModal = (e, flag, id = null) => {
        setOpenConfirmationModal(false);
        setCommonPopupParameters({});
        if (e && flag && flag === PlanFunctionsForFlag.CalculateConfirmation) {
            callPlanFunctionPostWithIdAPI(getPartialTrip, null, routeId, 'Microsoft.NAV.calculateIncludingActionTimes', e, flag, false, i18_en.operationSuccessful);
        } else if (e && flag && flag === PlanFunctionsForFlag.PlanMovementsNewConfirmation) {
            postPlanMovementsAPI(e, e.movementlines);
        } else if (e && flag && flag === PlanFunctionsForFlag.DeletePartialTrip) {
            e.confirmation = true
            const param = { input: JSON.stringify(e) }
            callPlanFunctionPostWithIdAPI(getPartialTrip, null, id, `Microsoft.NAV.deletePartialTrip`, param, flag, true, i18_en.operationSuccessful);
        }

        if (e === null && flag === undefined) {
            // clearMap();
            // dispatch(areaSelectionRefreshReducer({ isRefresh: true }));
        }
        setErrorMessage(null);
    }

    const menuItemsList = [
        { index: 3, separator: true, type: 'movements' }, { index: 4, text: 'Movement', callback: (e) => sendApi(e, 'getUrlMovement'), icon: TopicSvg, type: 'movements' },
        { index: 5, separator: true, type: 'movements' }, { index: 6, text: 'Shipment', callback: (e) => sendApi(e, 'getUrlShipment'), icon: localShippingSvg, type: 'movements' },
        { index: 7, separator: true, type: 'movements' }, { index: 8, text: 'File', callback: (e) => sendApi(e, 'getUrlFileTpt'), icon: descriptionSvg, type: 'movements' },
        { index: 9, separator: true, text: 'Plan on New Trip', type: 'movements' }, { index: 10, text: 'Plan on New Trip', callback: (e) => onPlanButtons(e, 'planOnNewTrip'), icon: modeOfTravelSvg, type: 'movements' },
        { index: 11, separator: true, type: 'partialTrips' }, { index: 12, text: 'Trip', callback: (e) => sendApi(e, 'getUrlTrip'), icon: modeOfTravelSvg, type: 'partialTrips' },
        { index: 13, separator: true, type: 'partialTrips' }, { index: 14, text: 'Partial Trip', callback: (e) => sendApi(e, 'getUrlPartialTrip'), icon: resourcesSvg, type: 'partialTrips' },
        { index: 15, separator: true, type: 'partialTrips' }, { index: 16, text: 'Resources', callback: (e) => sendApi(e, 'resources'), icon: partialTripSvg, type: 'partialTrips' },
        { index: 17, separator: true, text: 'Optimize route', type: 'partialTrips' }, { index: 18, text: 'Optimize route', callback: (e) => onPlanButtons(e, 'optimizeRoute'), icon: changeroutesicon, type: 'partialTrips' }, // disabled: true
        { index: 19, separator: true, text: 'Calculate Partial Trip', type: 'partialTrips' }, { index: 20, text: 'Calculate Partial Trip', callback: (e) => onPlanButtons(e, 'calculatePartialTrip'), icon: calculatoricon, type: 'partialTrips' },
        { index: 21, separator: true, text: 'Delete Trip', type: 'partialTrips' }, { index: 22, text: 'Delete Trip', callback: (e) => onPlanButtons(e, 'deleteTrip'), icon: trashBinSvg, type: 'partialTrips' },
        { index: 23, separator: true, text: 'Remove From Map', type: 'partialTrips' }, { index: 24, text: 'Remove From Map', callback: (e) => onPlanButtons(e, 'removeFromMap'), icon: deleteTripIconSvg, type: 'partialTrips' },
        { index: 25, separator: true, text: 'Set Free', type: 'partialTrips' }, { index: 26, text: 'Set Free', callback: (e) => onPlanButtons(e, 'setFree'), icon: shipmentmoveblicon, type: 'partialTrips' }

    ];

    const handleDateChange = event => {
        setCurrentDate(event.target.value);
    }

    const planNewTrip = () => {
        let actualSelectedIds = selectedIds, tempGridFlagVal = 'movements';
        if (drageItems.source == "movements") {
            actualSelectedIds = drageItems?.items?.map(e => e.id);
            tempGridFlagVal = drageItems.source;
        }
        let date = currentDate.getDate();
        let month = currentDate.getMonth() + 1;
        let year = currentDate.getFullYear();
        let tripDate = year + "-" + month + "-" + date;
        const movementObjects = service.movementObject(actualSelectedIds, tempGridFlagVal);
        const inputTripDateObject = {
            "tripDate": moment(tripDate).format('yyyy-MM-DD')
        };
        const obj = service.movementLinesAndOperationDeatilObject(movementObjects, JSON.stringify(inputTripDateObject), tempGridFlagVal);
        postPlanMovementsAPI(obj, movementObjects);
        setOpenPlanNewTripPopup(false);
    }

    const PlanNewTripData = (prop) => {
        if (prop?.sendDataToParent) {
            setTimeout(() => {
                prop.sendDataToParent("planNewPopup");
            }, 100);
        }

        return (
            <Box
                sx={{
                    bgcolor: "background.paper",
                    p: 2
                }}
                id="planNewPopup"
            >
                <Typography variant="body2" sx={{ pr: .5 }}>Trip Date:</Typography>

                <KendoDatePicker defaultValue={currentDate || null} min={minDate} max={maxDate} onChange={handleDateChange} required={true} format={"dd-MM-yyyy"} />
            </Box>
        )
    }

    const PlanNewTripActionButtons = () => {
        return (
            <>
                <Button variant="contained" style={{}} onClick={planNewTrip}>
                    OK
                </Button>
                <Button variant="outlined" onClick={() => setOpenPlanNewTripPopup(false)}>
                    Cancel
                </Button>
            </>
        )
    }

    // Common methods //
    const generateMarkers = (item, icon) => {
        const marker = L.marker([item.latitude, item.longitude],
            {
                item, icon, draggable: true,
                contextmenu: true,
                contextmenuItems: menuItemsList?.filter(e => (item.source == Consts.Movements && (e.type === item.source || e.text === "Remove From Map")) || (item.source == Consts.PartialTrips && e.type === item.source && e.text != "Remove From Map" && e.text != "Optimize route" && e.text != "Calculate Partial Trip" && e.text != "Delete Trip"))
            });
        // marker.bindPopup(() => onClickPopup(item, 'marker'));
        marker.bindTooltip(() => onClickPopup(item, 'marker')).openTooltip();
        marker.on('click', (e) => handleMarkerClick(e, item.actionNo, item.source));
        marker.on('contextmenu', (e) => handleMarkerClick(e, item.actionNo, item.source));
        marker.on('dragstart', onMarkerDragStart)
            .on('drag', (e) => onMarkerDragHandler(e, polylinesRef.current))
            .on('dragend', onMarkerDragEnd);
        return marker;
        // map.addLayer(marker);
    }

    const generatePolylines = (lstData, selected, _color, dottedLine) => {
        const line = lstData.map(e => [e.latitude, e.longitude])
        const polyline = L.polyline(line, {
            item: lstData[1], draggable: false,
            contextmenu: true, dottedLine: false, //REPLACE THIS 'dottedLine' AT FALSE FOR MAKE IT WORK
            contextmenuItems: menuItemsList?.filter(e => (lstData[1].source == Consts.Movements && (e.type === lstData[1].source || e.text === "Remove From Map")) || (lstData[1].source == Consts.PartialTrips && e.type === lstData[1].source && e.text != "Set Free"))
        });
        polyline.bindPopup(() => onClickPopup(lstData, 'polyline'));
        polyline.on('click', (e) => handlePolylineClick(e, lstData[1].source));
        polyline.on('contextmenu', (e) => handlePolylineRightClick(e, polyline));
        polyline.on('dragstart', onPolylineDragStart)
            .on('drag', onPolylineDragHandler)
            .on('dragend', onPolylineDragEnd);

        if (dottedLine) {
            polyline.setStyle({
                color: '#606060',
                weight: 4,
                initColor: '#606060',
                className: "dotted-polyline"
            });
        } else if (lstData[1]?.source === 'partialTrips') {
            polyline.setStyle({
                color: _color,
                weight: 5,
                initColor: _color,
                className: selected ? "custom-polyline" : '',
            });
        } else {
            polyline.setStyle({
                color: selected ? Consts.ColorSelected : Consts.ColorDefault,
                weight: 5,
                className: '',
                initColor: Consts.ColorDefault
            });
        }

        polyline.addTo(map);
        return polyline;
    }

    const handlePolylineRightClick = (e, polyline) => {
        const polylineData = polyline.options.item;
        routeId = polylineData.id;
        source = polylineData.source;
        handlePolylineClick(e, e?.sourceTarget?.options?.item?.source)
    };

    const generateColor = () => {
        const currentIndex = colorIndexRef.current;
        colorIndexRef.current = (currentIndex + 1) % service.polylineColorData.length;
        return service.polylineColorData[currentIndex];
    };

    // const getTooltip = (id, urlParam) => {
    //     try {
    //         const apiUrl = `${getShipmentActions}(${id})/Microsoft.NAV.${urlParam}`;
    //         return apiService.post(apiUrl, {}).then((res) => {
    //             if (res.value) {
    //                 return res.value;
    //             } else {
    //                 setErrorParameterAndMessage(res.error.message.split('CorrelationId')[0])
    //                 return null
    //             }
    //         })
    //     } catch (error) {
    //         console.error('Error in onIconClick:', error);
    //     }
    // };

    const onClickPopup = (item, type) => {
        if (type == 'marker') {
            // return getTooltip(item?.subid,'getTooltip')
            return "Action : " + item.actionNo + " <br/> " +
                "Address : [" + item.addressCode + "] " + item.addressName + ", " + item.addressStreet + ", " + item.city + ", " + item.country + " <br/> " +
                "Post code : " + item.postCode;
        } else {
            return "Start Action : " + item[0].actionNo + " <br/> " +
                "Address : [" + item[0].addressCode + "] " + item[0].addressName + ", " + item[0].addressStreet + ", " + item[0].city + ", " + item[0].country + " <br/> " +
                "Post code : " + item[0].postCode + "<hr> " +
                "End Action : " + item[1].actionNo + " <br/> " +
                "Address : [" + item[1].addressCode + "] " + item[1].addressName + ", " + item[1].addressStreet + ", " + item[1].city + ", " + item[1].country + " <br/> " +
                "Post code : " + item[1].postCode;
        }
    }
    // Common methods //

    // marker events start
    const changeMarkerStatus = (_layer, _status) => {
        _layer.options.item.selected = _status;
        _layer.options.selected = _status;
        return _layer;
    }

    const handleMarkerClick = (e, iconName, source) => {
        let selected = false;
        let selectedData = [];
        const field = (source === 'movements') ? 'id' : 'subid';
        const selectionfield = (source === 'movements') ? 'movementIds' : 'routeIds';

        let ctrlKeyPressed = e.originalEvent.ctrlKey;
        const layersKeys = _.entries(map._layers).filter(x => x[1]?.options?.item != undefined).map(p => p[0]);

        for (const key of layersKeys) {
            let layer = map._layers[key];
            if (layer?.options && layer?.options?.item?.id) {
                const _source = layer.options?.item?.source;
                const isExists = selectionData?.[selectionfield]?.some(x => x != e?.target?.options?.item?.[field])
                if ((layer.options?.item?.[field] === e?.target?.options?.item?.[field])) { // Self
                    if ((!isExists && layer.options.selected) || (ctrlKeyPressed && isExists && layer.options.selected)) { //isExists && ctrlKeyPressed && 
                        selected = false;
                    } else {
                        selected = true;
                    }
                } else if (layer.options?.item?.selected) { // Other-Selected
                    if (ctrlKeyPressed && isExists) { //isExists && ctrlKeyPressed &&
                        selected = true;
                    } else {
                        selected = false;
                    }
                } else {// Other-Deselcted
                    selected = false;
                }
                layer = changeMarkerStatus(layer, selected);

                if (_source === 'movements') {
                    const newIcon = service.createCustomIcon(service.generateIconWithSelection(layer.options?.item?.actionNo, layer.options.selected), map.getZoom());
                    layer?.setStyle ? layer.setStyle({ color: (layer.options.selected ? Consts.ColorSelected : Consts.ColorDefault) }) : layer?.setIcon(newIcon);

                    selectedData.push({ type: 'marker', id: layer?.options?.item?.id, subid: layer?.options?.item?.subid, isSelection: layer.options.selected, source: _source });
                } else if (_source === 'partialTrips') {
                    const newIcon = service.createCustomIcon(null, map.getZoom(), layer.options?.item?.sequenceNo, layer.options.selected);
                    layer?.setIcon && layer?.setIcon(newIcon);
                    selectedData.push({ type: 'marker', id: layer?.options?.item?.id, subid: layer?.options?.item?.subid, isSelection: layer.options.selected, source: _source });
                }
            }
        }

        dispatch(areaSelectionReducer({ layersData: _.uniqBy(selectedData.filter(q => q.source != Consts.PartialTrips), 'id') }));
        dispatchSelection(selectedData, 'marker');
    }

    const onMarkerDragStart = (e) => {
        const marker = e.target;
        initialPosMarkerRef.current?.set(marker._leaflet_id, marker.getLatLng());
    }

    const onMarkerDragHandler = (e) => {
        const markerLatLng = e.target.getLatLng();
        let _exists = false
        polylinesRef.current?.reverse()?.forEach(polyline => {
            if (polyline?.options?.item?.source != Consts.Movements) {
                if (!polyline?.options?.initColor) {
                    polyline.options.initColor = polyline?.options?.color ? polyline.options.color : Consts.ColorDefault;
                }
                const latlngs = polyline.getLatLngs();
                let isHovering = false;
                for (let i = 1; i < latlngs?.length; i++) {
                    const segmentStart = latlngs[i - 1];
                    const segmentEnd = latlngs[i];
                    const point = map.latLngToLayerPoint(markerLatLng);
                    const startPoint = map.latLngToLayerPoint(segmentStart);
                    const endPoint = map.latLngToLayerPoint(segmentEnd);
                    if (L.LineUtil.pointToSegmentDistance(point, startPoint, endPoint) <= 5) {
                        isHovering = true;
                        break;
                    }
                }
                if (isHovering && !_exists) {
                    polyline.setStyle({ color: Consts.ColorIntersect });
                    _exists = true
                } else {
                    polyline.setStyle({ color: polyline?.options?.initColor });
                }
            }
        });
    }

    const onMarkerDragEnd = (e) => {
        const marker = e.target;
        const dropLocation = marker.getLatLng();
        let isDropped = false;
        let disableDrop = false;
        const _len = polylinesRef?.current.filter(x => x?.options?.item?.id == e?.target?.options?.item?.id)?.length;
        if (_len && _len <= 1) {
            disableDrop = true;
        }
        polylinesRef?.current?.forEach(polyline => {
            if (polyline?.options?.item?.source != Consts.Movements && !disableDrop) {
                const point = map.latLngToLayerPoint(dropLocation);
                const latlngs = polyline?.getLatLngs()?.map(latlng => map.latLngToLayerPoint(latlng));
                for (let i = 1; i < latlngs.length; i++) {
                    const segmentStart = latlngs[i - 1];
                    const segmentEnd = latlngs[i];
                    if (L.LineUtil.pointToSegmentDistance(point, segmentStart, segmentEnd) <= 5) {
                        if (e?.target?.options?.item.source == Consts.PartialTrips) {
                            if (e?.target?.options?.item?.id == polyline?.options?.item?.id) {
                                const draggedSeq = e?.target?.options?.item?.sequenceNo;
                                const draggedId = e?.target?.options?.item?.subid;
                                const droppedSeq = polyline?.options?.item?.sequenceNo;
                                const droppedId = polyline?.options?.item?.subid;
                                if (droppedSeq < draggedSeq || droppedSeq > draggedSeq + 1) {
                                    const obj = { "input": "{\"beforeRouteId\" : \"" + droppedId + "\"}" }
                                    callPlanFunctionPostWithIdAPI(getRoutes, null, draggedId, 'Microsoft.NAV.moveRouteBeforeRoute', obj, true, i18_en.operationSuccessful);
                                } else {
                                    // setErrorSnackbarOpen(true);                                    
                                    // const template = _.template(i18_en.cantDropRouteOnRoute);
                                    // setErrorSnackbarMessage(template({draggedSeq, droppedSeq }));
                                }
                            } else {
                                setErrorSnackbarOpen(true);
                                setErrorSnackbarMessage(i18_en.workInProgress);
                            }
                        } else {
                            const movementIds = selectionData?.movementIds?.length > 0 ? selectionData?.movementIds : [e?.target?.options?.item?.id];
                            const tripId = polyline?.options?.item?.id;
                            const obj = { event: 'postPlanMovementsAPI', movIds: movementIds, tripId: tripId }
                            sendDataToParent(obj);
                        }
                        isDropped = true;
                        break;
                    }
                }
            }
            polyline.setStyle({ color: polyline?.options?.initColor });
        });
        const initialPos = initialPosMarkerRef.current.get(marker._leaflet_id);
        marker.setLatLng(initialPos);

    }

    const onDropEvent = (layerId) => {
        console.log("layerId", layerId)
    }

    // marker events end


    // polyline events start

    const handlePolylineClick = (e, source) => {
        // if (e?.target?.options?.item?.source == "partialTrips") {
        if (source) {
            let selected = false;
            let selectedData = [];
            const field = (source === 'movements') ? 'id' : 'subid';
            const selectionfield = (source === 'movements') ? 'movementIds' : 'partialTripIds';// 'routeIds';

            let ctrlKeyPressed = e.originalEvent.ctrlKey;
            const layersKeys = _.entries(map._layers).filter(x => x[1]?.options?.item != undefined).map(p => p[0]);

            for (const key of layersKeys) {
                let layer = map._layers[key];
                if (layer?.options && layer?.options?.item?.id) {
                    const _source = layer.options?.item?.source;
                    const isExists = selectionData?.[selectionfield]?.some(x => x != e?.target?.options?.item?.id)
                    if ((layer.options?.item?.[field] === e?.target?.options?.item?.[field]) || (_source === 'partialTrips' && layer.options?.item?.id === e?.target?.options?.item?.id)) { // Self
                        if ((!isExists && layer.options.selected) || (ctrlKeyPressed && isExists && layer.options.selected)) { //isExists && ctrlKeyPressed && 
                            selected = false;
                        } else {
                            selected = true;
                        }
                    } else if (layer.options?.item?.selected) { // Other-Selected
                        if (ctrlKeyPressed) { //isExists && ctrlKeyPressed &&
                            selected = true;
                        } else {
                            selected = false;
                        }
                    } else {// Other-Deselcted
                        selected = false;
                    }
                    layer = changeMarkerStatus(layer, selected);


                    if (_source === 'movements') {
                        const newIcon = service.createCustomIcon(service.generateIconWithSelection(layer.options?.item?.actionNo, layer.options.selected), map.getZoom());
                        layer?.setStyle ? layer.setStyle({ color: (layer.options.selected ? Consts.ColorSelected : Consts.ColorDefault) }) : layer?.setIcon(newIcon);
                        if (selected) { selectedData.push({ type: 'marker', id: layer?.options?.item?.id, subid: layer?.options?.item?.subid, isSelection: layer.options.selected, source: _source }); }
                    } else if (_source === 'partialTrips') {
                        const newIcon = service.createCustomIcon(null, map.getZoom(), layer.options?.item?.sequenceNo, layer.options.selected);
                        layer?.setIcon && layer?.setIcon(newIcon);
                        if (layer?.setStyle) {
                            const classlist = layer._path?.getAttribute('class');
                            if (layer.options.selected) {
                                layer._path?.setAttribute('class', classlist.concat(' custom-polyline'));
                            } else {
                                layer._path?.setAttribute('class', classlist.replaceAll('custom-polyline', ''));
                            }
                        }
                        // selectedData.push({ type: 'marker', id: layer?.options?.item?.id, subid: layer?.options?.item?.subid, isSelection: layer.options.selected, source: _source });
                        selectedData.push({ type: 'polyline', id: layer?.options?.item?.id, subid: layer?.options?.item?.subid, isSelection: layer.options.selected, source: _source });
                    }


                    // if ((layer.options?.item?.[field] === e?.target?.options?.item?.[field]) || (ctrlKeyPressed && layer.options.selected)) {
                    //     if (_source === 'movements') {
                    //         // const isExists = selectionData?.movementIds?.some(x => x != e.target.options.item.id)
                    //         if (layer.options.selected && (layer.options?.item?.[field] === e?.target?.options?.item?.[field])) { //isExists && ctrlKeyPressed && 
                    //             layer.options.item.selected = false;
                    //             layer.options.selected = false;
                    //         } else {
                    //             layer.options.item.selected = true;
                    //             layer.options.selected = true;
                    //         }
                    //         const newIcon = service.createCustomIcon(service.generateIconWithSelection(layer.options?.item?.actionNo, layer.options.selected), map.getZoom());
                    //         layer?.setStyle ? layer.setStyle({ color: (layer.options.selected ? Consts.ColorSelected : Consts.ColorDefault) }) : layer?.setIcon(newIcon);

                    //         selectedData.push({ type: 'marker', id: layer?.options?.item?.id, subid: layer?.options?.item?.subid, isSelection: layer.options.selected, source: _source });
                    //     } else if (_source === 'partialTrips') {
                    //         // const isExists = selectionData?.partialTripIds?.some(x => x != e.target.options.item.id)
                    //         if (layer.options.selected && (layer.options?.item?.[field] === e?.target?.options?.item?.[field])) { //isExists && ctrlKeyPressed && 
                    //             layer.options.item.selected = false;
                    //             layer.options.selected = false;
                    //         } else {
                    //             layer.options.item.selected = true;
                    //             layer.options.selected = true;
                    //         }
                    //         const newIcon = service.createCustomIcon(null, map.getZoom(), layer.options?.item?.sequenceNo, layer.options.selected);
                    //         layer?.setIcon && layer?.setIcon(newIcon);
                    //         if (layer?.setStyle) {
                    //             const classlist = layer._path?.getAttribute('class');
                    //             if (layer.options.selected) {
                    //                 layer._path?.setAttribute('class', classlist.concat(' custom-polyline'));
                    //             } else {
                    //                 layer._path?.setAttribute('class', classlist.replaceAll('custom-polyline', ''));
                    //             }
                    //         }
                    //         selectedData.push({ type: 'polyline', id: layer?.options?.item?.id, subid: layer?.options?.item?.subid, isSelection: layer.options.selected, source: _source });
                    //     }
                    // } else {
                    //     layer.options.item.selected = false;
                    //     layer.options.selected = false;
                    //     if (_source === 'movements') {
                    //         const newIcon = service.createCustomIcon(service.generateIconWithSelection(layer.options?.item?.actionNo, layer.options.selected), map.getZoom());
                    //         layer?.setStyle ? layer.setStyle({ color: (layer.options.selected ? Consts.ColorSelected : Consts.ColorDefault) }) : layer?.setIcon(newIcon);

                    //         selectedData.push({ type: 'marker', id: layer?.options?.item?.id, subid: layer?.options?.item?.subid, isSelection: layer.options.selected, source: _source });
                    //     } else if (_source === 'partialTrips') {
                    //         const newIcon = service.createCustomIcon(null, map.getZoom(), layer.options?.item?.sequenceNo, layer.options.selected);
                    //         layer?.setIcon && layer?.setIcon(newIcon);
                    //         if (layer?.setStyle) {
                    //             const classlist = layer._path?.getAttribute('class');
                    //             // if (classlist.indexOf('custom-polyline') !== -1) {
                    //             layer._path?.setAttribute('class', classlist.replaceAll('custom-polyline', ''));
                    //             // } else {
                    //             //     params._path?.setAttribute('class', classlist.concat(' custom-polyline'));
                    //             // }
                    //         }
                    //         selectedData.push({ type: 'polyline', id: layer?.options?.item?.id, subid: layer?.options?.item?.subid, isSelection: layer.options.selected, source: source });
                    //     }
                    // }
                }
            }
            dispatch(areaSelectionReducer({ layersData: _.uniqBy(selectedData, 'id') }));
            dispatchSelection(selectedData, 'polyline');
        }
    };

    const dispatchSelection = (selectedData, type) => {
        let partialTripIds = [];
        let movementIds = [];
        let routeIds = [];
        const getListSelection = storageService.getLocalStorageData('listSelection');
        let existingListSelection = getListSelection ? JSON.parse(getListSelection) : [];

        if (!existingListSelection.movementIds) existingListSelection.movementIds = [];
        if (!existingListSelection.partialTripIds) existingListSelection.partialTripIds = [];
        if (!existingListSelection.routeIds) existingListSelection.routeIds = [];

        if (type === 'polyline') {
            partialTripIds = selectedData.filter(x => x.isSelection && x.source === Consts.PartialTrips && x.type === 'polyline').map(x => x.id);
        } else {
            routeIds = selectedData.filter(x => x.isSelection && x.source === Consts.PartialTrips && x.type === 'marker').map(x => x?.subid);
        }
        movementIds = selectedData.filter(x => x.isSelection && x.source === Consts.Movements).map(x => x.id);

        existingListSelection.movementIds = movementIds.length > 0 ? _.uniq([...existingListSelection.movementIds, ...movementIds]) : existingListSelection.movementIds;
        existingListSelection.partialTripIds = partialTripIds.length > 0 ? _.uniq([...existingListSelection.partialTripIds, ...partialTripIds]) : existingListSelection.partialTripIds;
        existingListSelection.routeIds = routeIds.length > 0 ? _.uniq([...existingListSelection.routeIds, ...routeIds]) : existingListSelection.routeIds;

        dispatch(listSelectionReducer(existingListSelection));
        storageService.setLocalStorageData('listSelection', JSON.stringify(existingListSelection));
        selectionData = existingListSelection;
    };

    const onPolylineDragStart = (e) => {
        const polyline = e.target;
        const initialLatLngs = polyline?.getLatLngs();
        initialPosPolylineRef.current.set(polyline?._leaflet_id, initialLatLngs);
    }

    const onPolylineDragHandler = (e) => {
        const draggedPolyline = e.target;
        const draggedLatLngs = draggedPolyline?.getLatLngs()?.[0]?.map(latlng => map.latLngToLayerPoint(latlng));

        const isIntersecting = getIntersection(draggedPolyline, draggedLatLngs, polylineColor, 'drag');
    }

    const onPolylineDragEnd = (e) => {
        const draggedPolyline = e.target;
        const initialLatLngs = initialPosPolylineRef.current?.get(draggedPolyline?._leaflet_id);
        const draggedLatLngs = draggedPolyline?.getLatLngs()?.map(latlng => map.latLngToLayerPoint(latlng));

        const isIntersecting = getIntersection(draggedPolyline, draggedLatLngs, polylineColor, 'dragEnd');

        if (!isIntersecting) {
            draggedPolyline.setLatLngs(initialLatLngs?.[0]);
            alert('Polyline did not intersect with any other polyline, reverting to original position.');
        } else {
            const dropLocation = draggedPolyline.getLatLngs();
            const coords = dropLocation?.map(item => [item.lat, item.lng]);
            alert(`Polyline Drop location: [${coords}]`);
        }
    }

    const getIntersection = (draggedPolyline, draggedLatLngs, polylineColor, flag) => {
        let isIntersecting = false;
        polylinesRef.current?.forEach(polyline => {
            if (polyline !== draggedPolyline) {
                const latlngs = polyline.getLatLngs()?.map(latlng => map.latLngToLayerPoint(latlng));

                for (let i = 1; i < latlngs.length; i++) {
                    const segmentStart1 = latlngs[i - 1];
                    const segmentEnd1 = latlngs[i];

                    for (let j = 1; j < draggedLatLngs.length; j++) {
                        const segmentStart2 = draggedLatLngs[j - 1];
                        const segmentEnd2 = draggedLatLngs[j];

                        if (service.routesIntersect(segmentStart1, segmentEnd1, segmentStart2, segmentEnd2)) {
                            isIntersecting = true;
                            polyline.setStyle({ color: flag === 'dragEnd' ? Consts.ColorDropped : Consts.ColorIntersect });
                            break;
                        }
                    }
                    if (isIntersecting) break;
                }

                if (!isIntersecting) {
                    polyline.setStyle({ color: polylineColor });
                }
            }
        });
        return isIntersecting;
    }

    // polyline events end

    return (
        <>
            {openConfirmationModal && <ModalComponent message={errorMessage} params={commonPopupParameters} openConfirmationModal={openConfirmationModal} closeConfirmationModal={closeConfirmationModal} />}
            <AlertComponent isSuccessSnackbarOpen={isSuccessSnackbarOpen} successSnackbarMessage={successSnackbarMessage} handleSuccessSnackbarClose={handleSuccessSnackbarClose} isErrorSnackbarOpen={isErrorSnackbarOpen} errorSnackbarMessage={errorSnackbarMessage} handleErrorSnackbarClose={handleErrorSnackbarClose} isDisplayDrillDownButton={isDisplayDrillDownButton} drillDownButtonURL={drillDownButtonURL} />

            {/*open modal for plan on new trip details */}
            {openPlanNewTripPopup && <WindowComponent title={"Plan New Trip"} visible={openPlanNewTripPopup} initialWidth={420} initialHeight={200} minWidth={420} minHeight={200} onClose={() => setOpenPlanNewTripPopup(false)} dataComponent={PlanNewTripData} actionButtons={<PlanNewTripActionButtons />} />}
        </>
    );
});

export default ClusterComponent;